import React from "react";
import UiMainWrapper from "../../components/common/UiMainWrapper"

import TopHeader from "../../components/header/TopHeader"
import { UiBannerBottomBar } from '../../components/common/UiBannerBottomBar';
import UiInnerBanner from "../../components/common/UiInnerBanner";
import { UiContentCol, UiContentWr, UiTabContentWr } from "../../components/common/UiPageElements";
import { UiCol, UiRowContainer } from "../../components/grid-container/GridContainer";
import { MakeSenseStatement } from "./views/MakeSenseStatement";
import Footer from "../../components/footer/Footer";
import { BalanceTransactions } from "./views/BalanceTransactions";
import { UiScrollNavItem, UiScrollNavWr } from "../../components/common/UiScrollToElements";
import { RecentPoints } from "../Sidebar/RecentPoints";
import { PointsCard } from "../Sidebar/PointsCard";
import { WishList } from "../Sidebar/WishList";
import { GoalCard } from "../Sidebar/GoalCard";
import { PendingTransaction } from "./views/PendingTransactions";
import { AccountHistory } from "./views/AccountHistory";
import { GiftPoints } from "./views/GiftPoints";
import { PurchaseTopUp } from "./views/PurchaseTopUp";

export const PointsBanking = () => {
    return (
        <>
            <UiMainWrapper>
                <TopHeader />
                <UiInnerBanner
                    title="My Statement"
                    description="Keep a track of your sweet rewards" />

                <UiBannerBottomBar
                    prevPage="Shop"
                    prevPageLink="/ui"
                    currentPage="My Statement"
                    currentPageLink="/ui" />

                <BalanceTransactions />

                <UiContentWr>
                    <UiRowContainer fluid="fluid">
                        <UiCol lg="12">
                            <UiContentCol>
                                <MakeSenseStatement title="Make sense of your statement" />
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>

                <UiContentWr>
                    <UiTabContentWr>
                        <UiRowContainer fluid="fluid" className="sb-pb-tab">
                            <UiScrollNavWr>
                                <UiScrollNavItem hash="account-history" hashText="Account History" />
                                <UiScrollNavItem hash="" hashText="Gift Points" />
                                <UiScrollNavItem hash="" hashText="Top-Up Points" />
                            </UiScrollNavWr>
                        </UiRowContainer>
                    </UiTabContentWr>
                </UiContentWr>

                <UiContentWr id="account-history" >
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="12" xl="9" className="sb-tr-hist">
                            <PendingTransaction />
                            <AccountHistory />
                        </UiCol>
                        <UiCol lg="6" xl="3" className="sb-sidebar-col">
                            <UiContentCol>
                                <RecentPoints />
                                <PointsCard />
                                <WishList />
                                <GoalCard />
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>


                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="6">
                           <GiftPoints />
                        </UiCol>  
                        <UiCol lg="6">
                           <PurchaseTopUp />
                        </UiCol>                       
                    </UiRowContainer>
                </UiContentWr>


                <Footer />

            </UiMainWrapper>

        </>
    )
}